export const ENTITY_NAME = 'PERSON_';
export const DOCUMENT = 'DOCUMENT_';
export const BONUS_CARD = 'BONUS_CARD_';
export const CONTACT = 'CONTACT_';
export const SET_TAB_PERSON = "SET_TAB_PERSON";
export const PREF_DATA = "PREF_DATA_";
export const VISA = "VISA_"